import {
  BottomSheet as SharedBottomSheet,
  Drawer as SharedDrawer,
  type BottomSheetProps,
  type DrawerProps,
} from 'pi-kiosk-shared/ui';

export type { BottomSheetProps, DrawerProps };

/** Customer sheets: cap at max-w-lg (same family as Dialog) — never shell-wide on desktop. */
const CUSTOMER_SHEET_MAX_CLASS = 'max-w-lg';

export function BottomSheet({ className, ...rest }: BottomSheetProps): JSX.Element {
  return (
    <SharedBottomSheet
      {...rest}
      className={[CUSTOMER_SHEET_MAX_CLASS, className].filter(Boolean).join(' ')}
    />
  );
}

export function Drawer({ className, ...rest }: DrawerProps): JSX.Element {
  return (
    <SharedDrawer
      {...rest}
      className={[CUSTOMER_SHEET_MAX_CLASS, className].filter(Boolean).join(' ')}
    />
  );
}
